import { Component } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemActionParamService } from '../crud-service';
import { SystemActionParamCrudIndex } from './crud-index';
import { SystemActionCategoryTypeEnum } from 'src/app/domain/registration/enums/system-action-category-type.enum';

@Component({
  selector: 'app-system-action-param-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemActionParamService],
})
export class SystemActionParamIndexComponent extends SystemActionParamCrudIndex {
  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Código',
      name: 'code',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'Tipo de Ação do Sistema',
      name: 'systemActionCategoryType',
      options: Object.values(SystemActionCategoryTypeEnum),
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Ação do Sistema',
      name: 'systemAction',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
  ];
}
